export class RegularExpression{

    public static Rut (value:any) {
        return RegExp("^([0-9]{7,8}[-][0-9Kk])$").test(value);
    }
}


